// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1crOc","delete":"styles_delete__2og96","update":"styles_update__2zNqg","add":"styles_add__1Sgf6"};